type IsFileTypeAcceptedParams = {
  /** The MIME type of the file (e.g., "image/jpeg") */
  fileType: string;
  /** Comma-separated list of accepted MIME types or wildcards (e.g., "image/*,video/mp4") */
  accept: string;
};

/**
 * Check if a file MIME type matches an accept string (e.g., "image/jpeg,image/png" or "image/*")
 * @returns true if the file type is accepted
 */
const isFileTypeAccepted = ({
  fileType,
  accept,
}: IsFileTypeAcceptedParams): boolean => {
  return accept.split(',').some((acceptType) => {
    const trimmed = acceptType.trim();
    if (trimmed.endsWith('/*')) {
      // Wildcard match (e.g., "image/*" matches "image/jpeg")
      const category = trimmed.replace('/*', '');
      return fileType.startsWith(`${category}/`);
    }
    return fileType === trimmed;
  });
};

export default isFileTypeAccepted;
